/**
 * Formats an hour number into a 12hr time
 */
export const formatHour = (hour: number) =>
  `${hour % 12 || 12}:00 ${hour < 12 ? 'AM' : 'PM'}`;

/**
 * Formats the given string as hex
 */
export function toHex(str: string) {
  let result = '';
  for (let i = 0; i < str.length; i += 1) {
    result += str.charCodeAt(i).toString(16);
  }
  return result;
}

// Used for parsing circular reference objects
export const safeStringify = (obj: any, indent = 2) => {
  let cache: any[] | null = [];
  const retVal = JSON.stringify(
    obj,
    (_key, value) => {
      if (typeof value === 'object' && value !== null) {
        return cache?.includes(value)
          ? undefined // Duplicate reference found, discard key
          : cache?.push(value) && value; // Store value in our collection
      }
      return value;
    },
    indent,
  );
  cache = null;
  return retVal;
};
